export default {
  'head_siderails': {
    en: 'Folding of Head Siderails',
    track: 'head_siderails'
  },
  'middle_siderails': {
    en: 'Folding of Middle Siderails',
    track: 'middle_siderails'
  },
  'protektor': {
    en: 'Folding of Protector Siderails',
    track: 'protektor'
  },
  'protektor_reverse': {
    en: 'Folding of Protector Siderails',
    track: 'protektor_reverse'
  },
  'max_to_min': {
    en: 'Bed Height Adjustment Down',
    track: 'max_to_min'
  },
  'min_to_max': {
    en: 'Bed Height Adjustment Up',
    track: 'min_to_max'
  },
  'trendelenburg_z_max': {
    en: 'Trendelenburg',
    track: 'trendelenburg_z_max'
  },
  'reverse_trendelenburg_z_max': {
    en: 'Trendelenburg',
    track: 'reverse_trendelenburg_z_max'
  },
  'reverse_trendelenburg_z_min': {
    en: 'Reverse Trendelenburg',
    track: 'reverse_trendelenburg_z_min'
  },
  'trendelenburg_z_min': {
    en: 'Reverse Trendelenburg',
    track: 'trendelenburg_z_min'
  },
  'backrest_adjustment_30': {
    en: 'Backrest Adjustment',
    track: 'backrest_adjustment_30'
  },
  'backrest_adjustment_70': {
    en: 'Backrest Adjustment',
    track: 'backrest_adjustment_70'
  },
  'autocontour': {
    en: 'Autocontour',
    track: 'autocontour'
  },
  'thightrest_adjustment': {
    en: 'Thighrest Adjustment',
    track: 'thightrest_adjustment'
  },
  'calfrest_adjustment': {
    en: 'Calfrest Adjustment',
    track: 'calfrest_adjustment'
  }
}